<template>
  <div class="app-page-title">
    <div class="page-title-wrapper">
      <div class="page-title-heading">
        <div v-if="icon.length > 0" class="page-title-icon">
          <i class="icon-gradient bg-midnight-bloom" :class="icon">
          </i>
        </div>
        <div>
            <span v-html="title"/>
            <small class="d-block">
                <slot name="subTitle"/>
            </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageTitle",
  props: {
    title: { default: ''},
    icon: { default: ''},
  }
}
</script>

<style scoped>

</style>
